// useMediaQuery - media query as React state, plus named breakpoint helpers.

import { useEffect, useState } from 'react';

// Media query as React state (SSR-safe). Use sparingly - prefer Tailwind
// classes for CSS toggles; this is for when the component identity differs
// (popover vs. bottom sheet) rather than just styling.
export function useMediaQuery(query: string): boolean {
  const get = () =>
    typeof window !== 'undefined' && window.matchMedia(query).matches;
  const [matches, setMatches] = useState<boolean>(get);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// Named helpers - query strings in one place, mirroring Tailwind's
// breakpoints (sm 640, md 768, lg 1024).
export const useIsMobile = () => useMediaQuery('(max-width: 767px)');
export const usePrefersReducedMotion = () =>
  useMediaQuery('(prefers-reduced-motion: reduce)');
